import { ThemeType } from 'theme/jss-types';
import { commonStyles } from './single-consignment.styles';

export const summaryStepStyles = (theme: ThemeType) => ({
    ...commonStyles(theme),
    main: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
    },
    summaryCardCollapse: {
        backgroundColor: 'transparent',
        border: 'none',
        '& .ant-collapse-item': {
            backgroundColor: '#FFFFFF',
            borderRadius: 8,
            overflow: 'hidden',
        },
        '& .ant-collapse-header': {
            padding: '16px 20px !important',
            fontWeight: 600,
            fontSize: '16px !important',
            alignItems: 'center !important',
        },
        '& .ant-collapse-content-box': {
            padding: '0px 20px !important',
        },
        '& .ant-collapse-arrow': {
            fontSize: '14px !important',
        },
    },
    summaryCardCollapseMobile: {
        backgroundColor: 'transparent',
        border: 'none',
        '& .ant-collapse-item': {
            marginBottom: 16,
            backgroundColor: '#FFFFFF',
            borderRadius: 8,
            overflow: 'hidden',
        },
        '& .ant-collapse-header': {
            padding: '16px 20px !important',
            fontWeight: 600,
            fontSize: '16px !important',
            alignItems: 'center !important',
        },
        '& .ant-collapse-content-box': {
            padding: '0px 20px !important',
        },
        '& .ant-collapse-arrow': {
            fontSize: '14px !important',
        },
    },
    section: {
        display: 'flex',
        padding: '10px',
        borderBottom: '1px solid #EDEDED',
    },
    fields: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
    },
    edit: {
        cursor: 'pointer',
        textAlign: 'center',
        fontWeight: 600,
        color: theme.primaryColor,
    },
    tabDetails: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'start',
    },
    pieceTabDetails: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'start',
        rowGap: '10px',
    },
    fieldGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        overflowWrap: 'break-word',
        alignItems: 'start',
        fontSize: 12,
        flexDirection: 'column',
        paddingRight: '8px',
    },
    fieldTitle: {
        display: 'inline-block',
    },
    fieldValue: {
        display: 'inline-block',
        fontWeight: 600,
    },
    collapse: {
        '& .ant-collapse-header': {
            padding: '8px 32px 8px 12px !important',
            width: 'fit-content',
        },
    },
    pieceReferenceNumberStyle: {
        display: 'inline-block',
        maxWidth: '12ch',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});
